import { Component, EventEmitter, OnInit, Input, Output, OnChanges, SimpleChanges } from '@angular/core'; // Added OnChanges, SimpleChanges
import { Resources } from 'src/app/core/models/resource.model';

@Component({
  selector: 'wf-knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.css'],
  standalone: false,
})

export class KnowledgeBaseComponent implements OnInit, OnChanges { // Implemented OnChanges
  @Input() resources: Resources[] = [];
  @Output() itemClicked = new EventEmitter<Resources>();

  quickGuideResources: Resources[] = [];
  otherResources: Resources[] = [];

  constructor() { }

  ngOnInit(): void {
    this.processResources();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resources'] && changes['resources'].currentValue) {
      this.processResources();
    }
  }

  private processResources(): void {
    if (!this.resources || this.resources.length === 0) {
      this.quickGuideResources = [];
      this.otherResources = [];
      return;
    }

    this.quickGuideResources = this.resources.filter(resource => resource.quickGuide === true);
    this.otherResources = this.resources.filter(resource => !resource.quickGuide);
  }

  goToItem(resource: Resources): void {
    this.itemClicked.emit(resource);
  }

  trackByResourceTitle(index: number, resource: Resources): string {
    return resource.title || `${index}`;
  }
}